module.exports = __webpack_public_path__ + "static/media/NewsHeaderBackgroundImage.5fa4b7b2.png";